// extracted by mini-css-extract-plugin
export default {"wrapper":"carImage_wrapper__5Qvm8","img":"carImage_img__eMDPZ"};